import React from "react";
import PageHero from "../components/PageHero";
import { CheckCircle2, MessageCircle, KeyRound, Wallet, Play, Trophy, Smartphone, ShieldCheck } from "lucide-react";
import { SITE, IMAGES } from "../data/mock";

export default function HowToPlay() {
  const steps = [
    { icon: MessageCircle, title: "Step 1: WhatsApp par Contact karein", desc: "Hamare official WhatsApp link par click karke 'Get Cricket ID' likhkar bhejein. Support team turant respond karegi." },
    { icon: KeyRound, title: "Step 2: ID aur Password Receive karein", desc: "Apna preferred username share karein. 2 minute ke andar verified ID aur password mil jayega." },
    { icon: Wallet, title: "Step 3: Wallet me Deposit karein", desc: "Minimum ₹100 se start. UPI, Bank Transfer ya USDT - jis se comfortable ho, use karein. Deposit instant credit hota hai." },
    { icon: Play, title: "Step 4: Game/Match Select karein", desc: "Cricket, football, tennis, casino - 650+ games me se apni pasand chunein. Live odds aur streaming dono available." },
    { icon: Trophy, title: "Step 5: Bet Place aur Win karein", desc: "Back/Lay options se bet lagayein. Match khatam hone par jeet ki amount instant credit. Withdrawal bhi 3-5 min me." },
  ];
  return (
    <div>
      <PageHero title="How to Play on OnlineCricketID" breadcrumb="How to Play" subtitle="Complete step-by-step guide - WhatsApp par message bhejne se leke pehli bet jeetne tak. Sirf 5 minute me start ho jao." />

      <section className="section-pad">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-5">
            {steps.map((s, i) => (
              <div key={i} className="card-dark p-6 grid md:grid-cols-[64px_1fr] gap-5 items-start">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-[#0a1226] shadow-lg shadow-amber-500/20">
                  <s.icon className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">{s.title}</h3>
                  <p className="mt-2 text-slate-300 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-10 text-center">
            <a href={SITE.whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center gap-2 px-6 py-3.5 rounded-xl">
              <MessageCircle className="w-5 h-5" /> Start on WhatsApp
            </a>
          </div>
        </div>
      </section>

      <section className="section-pad bg-gradient-to-b from-transparent via-[#0c1530]/40 to-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
          <div className="rounded-3xl overflow-hidden border border-amber-500/20">
            <img src={IMAGES.batting} alt="Cricket batting" className="w-full h-[420px] object-cover" />
          </div>
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-white">Cricket Betting Markets Explained</h2>
            <p className="mt-3 text-slate-300">OnlineCricketID par aapko milte hain saare popular betting markets. Yahan se choose karke smart play karein.</p>
            <ul className="mt-6 space-y-3">
              {[
                { t: "Match Winner", d: "Jeetne wali team par bet — sabse popular market." },
                { t: "Toss Winner", d: "Match shuru hone se pehle toss par bet lagayein." },
                { t: "Top Batsman/Bowler", d: "Match ka best performer kaun hoga - smart picks." },
                { t: "Powerplay Runs", d: "Pehle 6 overs me kitne runs banenge — high action market." },
                { t: "Session Bets", d: "Specific overs me runs/wickets ka prediction." },
                { t: "Live In-Play", d: "Match chalte hue live odds par instant decisions." },
              ].map((x) => (
                <li key={x.t} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 mt-0.5 shrink-0" />
                  <div><span className="text-white font-semibold">{x.t}:</span> <span className="text-slate-300">{x.d}</span></div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white">Smart Play Tips</h2>
            <p className="mt-3 text-slate-400">Anna ke 10 saal ke experience se kuch zaruri tips taaki aap responsible aur smart play kar sakein.</p>
          </div>
          <div className="mt-8 grid sm:grid-cols-2 gap-5">
            {[
              { icon: ShieldCheck, t: "Apni Limit Tay Karein", d: "Roz/Hafte ki maximum amount fix karein. Loss recover karne ke liye over-bet kabhi mat karein." },
              { icon: Smartphone, t: "Live Data Use Karein", d: "Pitch report, weather, team news - sab dekhke decision lein. Andhi taur par bet mat lagayein." },
              { icon: Wallet, t: "Bankroll Management", d: "Total budget ka sirf 1-5% ek bet par lagao. Long-term me sustainable." },
              { icon: Trophy, t: "Familiar Markets se Start Karo", d: "Match Winner aur Toss jaise simple markets se shuru karo, fir advanced markets explore karo." },
            ].map((x) => (
              <div key={x.t} className="card-dark p-5">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center"><x.icon className="w-5 h-5 text-amber-400" /></div>
                  <h3 className="text-base font-bold text-white">{x.t}</h3>
                </div>
                <p className="mt-3 text-sm text-slate-400">{x.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
